<template>
    <div class="reach-out-container">
      <div class="text-content">
        <div class="big-glowbe">
            <img src="/figures/lore/big-glowbe.png" alt="Big Glowbe" />
        </div>
        <div class="reach-out-title">Reach Out!</div>
        <div class="reach-out-subtitle">We'd love to hear from you.</div>
        <div class="reach-out-links">
          <span>Surf the Sneakernet</span>
          <a href="/" class="button cta-button"><span>Join the Club</span> →</a>
          <span>Carry What Matters</span>
        </div>
      </div>
  
      <div class="scroller-container" ref="container">
        <div class="weaving-glowbe" :style="glowbeStyle">
            <Glowbe />
        </div>
        <div class="weaving-glowbe" :style="glowbeStyle2">
            <Glowbe />
        </div>

        <div
          v-for="(illo, index) in illustrations"
          :key="index"
          class="floating-illo"
          :style="getIlloStyle(index)"
        >
            <div class="illo-container" :style="getIlloContainerStyle(index)">
                <component :is="illo.component" />
            </div>
            <div class="illo-shadow">
                <img src="/figures/lore/glows.png" alt="Illo Shadow" />
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { markRaw } from 'vue'

  import FilesFolder from '../Lore/illos/FilesFolder.vue'
    import LaptopBig from '../Lore/illos/LaptopBig.vue'
    import USBKeysBig from '../Lore/illos/USBKeysBig.vue'
    import Console from '../Lore/illos/Console.vue'
    import Transport from '../Lore/illos/Transport.vue'
    import ShareHand from '../Lore/illos/ShareHand.vue'
    import Glowbe from '../Glowbe.vue'

  export default {
    name: "ReachOutFooter",
    components: {
        FilesFolder,
        LaptopBig,
        USBKeysBig,
        Console,
        Transport,
        ShareHand,
        Glowbe
    },
    data() {
        return {
            globalOffset: 0,
            autoScrollSpeed: -0.03,
            animationFrameId: null,
            containerWidth: 0,
            glowbePosition: 0, 
            glowbePosition2: 0, // Start second glowbe at 0
            illustrations: [
                { name: 'Laptop', component: markRaw(LaptopBig) },
                { name: 'USBKeys', component: markRaw(USBKeysBig) },
                { name: 'FilesFolder', component: markRaw(FilesFolder) },
                { name: 'Console', component: markRaw(Console) },
                { name: 'Transport', component: markRaw(Transport) },
                { name: 'ShareHand', component: markRaw(ShareHand) },
            ]
        }
    },
    computed: {
      totalWidth() {
        return this.illustrations.length * this.currentSpacing;
      },
      currentSpacing() {
        return window.innerWidth <= 768 ? 200 : 350; // Adjust spacing for mobile
      },
      glowbeStyle() {
            return this.getGlowbeStyle(this.glowbePosition);
        },
        glowbeStyle2() {
            return this.getGlowbeStyle(this.glowbePosition2);
        }
    },
    mounted() {
      this.containerWidth = this.$refs.container.offsetWidth;
      this.glowbePosition2 = this.totalWidth / 2;
      this.startAnimationLoop();
      window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
      cancelAnimationFrame(this.animationFrameId);
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.containerWidth = this.$refs.container.offsetWidth;
        },
        getGlowbeStyle(position) {
            const x = position % this.totalWidth;
            const progress = (x % this.currentSpacing) / this.currentSpacing;
            const scale = 0.8 + Math.sin(progress * Math.PI) * 0.2;
            
            const yOffset = Math.sin(x / 50) * 20;
            
            const currentIllo = Math.floor(x / this.currentSpacing);
            const zIndex = currentIllo % 2 === 0 ? 2 : 0;

            return {
                position: 'absolute',
                left: `${x}px`,
                transform: `scale(${scale}) translateY(${yOffset}px)`,
                zIndex: zIndex,
                transition: 'z-index 0.01s',
                width: '80px',
                height: '80px'
            }
        },
        getIlloX(index) {
            let offsetMod = this.globalOffset % this.totalWidth;
            if (offsetMod < 0) offsetMod += this.totalWidth;
            let x = index * this.currentSpacing - offsetMod;
            
            if (x > this.containerWidth) {
            x -= this.totalWidth;
            }
            if (x < -this.currentSpacing) {
            x += this.totalWidth;
            }
            return x;
        },
        startAnimationLoop() {
            let lastTime = performance.now();
            const animate = (currentTime) => {
                const deltaTime = currentTime - lastTime;
                lastTime = currentTime;
                
                // Auto-scroll illustrations
                this.globalOffset += this.autoScrollSpeed * deltaTime;
                
                // Move both glowbes
                const glowbeSpeed = Math.abs(this.autoScrollSpeed * 4) * deltaTime;
                this.glowbePosition += glowbeSpeed;
                this.glowbePosition2 += glowbeSpeed;
                
                if (this.glowbePosition > this.totalWidth) {
                    this.glowbePosition = 0;
                }
                if (this.glowbePosition2 > this.totalWidth) {
                    this.glowbePosition2 = 0;
                }
                
                this.animationFrameId = requestAnimationFrame(animate);
            };
            this.animationFrameId = requestAnimationFrame(animate);
        },
    //   startAnimationLoop() {
    //     let lastTime = performance.now();
    //     const animate = (currentTime) => {
    //       const deltaTime = currentTime - lastTime;
    //       lastTime = currentTime;
          
    //       // Auto-scroll
    //       this.globalOffset += this.autoScrollSpeed * deltaTime;
          
    //       this.animationFrameId = requestAnimationFrame(animate);
    //     };
    //     this.animationFrameId = requestAnimationFrame(animate);
    //   },
      getIlloStyle(index) {
        return {
          left: `${this.getIlloX(index)}px`,
        }
      },
      getIlloContainerStyle(index) {
        return {
            animation: `float 2.5s ease-in-out infinite alternate`,
            animationDelay: `${(index % 2) * 1.25}s`
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .reach-out-container {
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    width: 100vw;
    padding: 4rem 0;
    color: white;
    overflow: hidden;
  }
  
  .text-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    margin-bottom: 4rem;
  }

  .big-glowbe {
    width: 32rem;
    height: 32rem;
    margin-bottom: -12rem;
    z-index: 10;
    animation: float 5s ease-in-out infinite;
  }
  
  .reach-out-title {
    font-size: 8rem;
    line-height: 0.9;
    font-family: "Ogg", serif;
    color: #ffffff;
  }
  
  .reach-out-subtitle {
    font-size: 4.5rem;
    font-family: "Asimov", sans-serif;
    color: #ffffff;
  }

  .reach-out-links {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2.4rem;
    color: #BEBEBE;
    font-family: "Asimov", sans-serif;
    font-size: 2.4rem;
    margin-top: 6.2rem;
  }
  
  .scroller-container {
    overflow: hidden;
    position: relative;
    padding-top: 2.4rem;
    width: 100%;
    margin-top: 12rem;
    height: 24rem;
  }
  
  .floating-illo {
    position: absolute;
    width: 300px;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    }

    .floating-illo .illo-shadow {
        width: 100%;
        height: auto;
    }

    .floating-illo .illo-container {
        height: 190px;
    }

    /* Update the img selector to target SVG elements */
    /* .floating-illo :deep(svg) {
        width: 100%;
        height: auto;
    } */
  
  @keyframes float {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(-20px);
    }
  }

.weaving-glowbe {
    position: absolute;
    top: 50%;
    transform-origin: center;
    pointer-events: none;
}

.weaving-glowbe :deep(svg) {
    width: 100%;
    height: 100%;
}

@keyframes float {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
    .reach-out-title {
        font-size: 5.5rem;
        line-height: 1.1;
    }
    .reach-out-subtitle {
        font-size: 2.9rem;
    }
    .reach-out-links {
        flex-direction: column;
    }

    .big-glowbe {
        width: 24rem;
        height: 24rem;
        margin-bottom: -9rem;
    }

    .floating-illo {
        width: 170px;
    }

    .floating-illo .illo-container {
        height: 173px;
    }

    .floating-illo .illo-container svg {
        width: 30vw;
    }
}

  </style>